module.exports = __webpack_public_path__ + "img/10-consumers-microlines.png";